import React from 'react';
import { MealPreferencesDialogView } from '../../store/types';
import AllergyPreferencesView from '../AllergyPreferencesView';
import AvoidPreferencesView from '../AvoidPreferencesView';
import BudgetPreferencesView from '../BudgetPreferencesView';
import DietaryBalancePreferenceView from '../DietaryBalancePreferenceView';
import { EatMeatView } from '../EatMeatView';
import MainPreferencesView from '../MainPreferencesView';
import { MealRemindersView } from '../MealRemindersView';
import { MealsToPlanView } from '../MealsToPlanView';
import { MeatTypesView } from '../MeatTypesView';
import PeoplePreferencesView from '../PeoplePreferencesView';
import TimeAndEffortPreferenceView from '../TimeAndEffortPreferenceView';

interface Props {
  view: MealPreferencesDialogView;
}

const PreferencesViewSwitch = (props: Props) => {
  switch (props.view) {
    case 'main':
      return <MainPreferencesView />;
    case 'allergies':
      return <AllergyPreferencesView />;
    case 'avoidances':
      return <AvoidPreferencesView />;
    case 'budget':
      return <BudgetPreferencesView />;
    case 'diet_balance':
      return <DietaryBalancePreferenceView />;
    case 'time_and_effort':
      return <TimeAndEffortPreferenceView />;
    case 'people':
      return <PeoplePreferencesView />;
    case 'eats_meat':
      return <EatMeatView />;
    case 'meat_types':
      return <MeatTypesView />;
    case 'meals_to_plan':
      return <MealsToPlanView />;
    case 'reminders':
      return <MealRemindersView />;
  }
};

export default PreferencesViewSwitch;
